import { Directive, ElementRef, HostBinding, HostListener, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[cf-input]',
  standalone: true,
})
export class InputDirective {
  // eslint-disable-next-line no-untranslated-string/no-untranslated-string
  @HostBinding('class') classes = 'cf-input form-control';

  public focused$: Observable<boolean>;

  private hasErrorsBeh$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public hasErrors$: Observable<boolean> = this.hasErrorsBeh$.asObservable();

  private focusedStream$ = new BehaviorSubject<boolean>(false);

  constructor(
    public elementRef: ElementRef<HTMLInputElement>,
    @Optional() @Self() public ngControl: NgControl,
  ) {
    this.focused$ = this.focusedStream$.asObservable().pipe(debounceTime(1));
  }

  @HostListener('focus', ['true'])
  @HostListener('blur', ['false'])
  focusChanged(isFocused: boolean): void {
    if (
      isFocused !== this.focusedStream$.value &&
      (!this.elementRef.nativeElement.readOnly || !isFocused)
    ) {
      this.focusedStream$.next(isFocused);
    }
  }

  @HostListener('change', ['$event'])
  handleChange(): void {
    const value = this.ngControl?.errors;
    this.hasErrorsBeh$.next(value != null && `${value}` !== 'false');
  }
}
